<template>
<div class="header">
  <div class="header-item header-menu" @click="toggleSidebar()">
    <div class="header-hamburger" :class="{active: showSidebar}"></div>
  </div>

  <div class="header-logo" @click="goHome">
    <img src="../assets/logo.png" alt="Stocker 3.0">
  </div>

  <button class="header-item header-logout button iconOnly"
          type="button"
          @click="logout"
          v-show="user != null">
    <i class="i">exit_to_app</i>
  </button>
</div>
</template>

<script>
import firebase from 'firebase';
import * as Firebase from '../config.js';
import { mapState, mapMutations } from 'vuex';

export default {
  data(){ return{

  }},

  computed: {
    ...mapState([
      'user',
      'showSidebar'
    ])
  },

  methods: {
    goHome(){
      this.$router.push('/');
    },

    logout(){
      firebase.auth().signOut().then(() => {
        this.$router.push('login');
      }, error => {
        console.log('Sign out error');
      });
    },

    ...mapMutations([
      'toggleSidebar'
    ])
  },

  mounted(){
  }
}
</script>



// WEBPACK FOOTER //
// header.vue?37c988c7